// extracted by mini-css-extract-plugin
export default {"form-control":"CourseInput_form-control__vw1v1","inValid":"CourseInput_inValid__Diaxf"};